import { Thunk } from 'ha/myredux/types';
import { AuthLogicActions } from './actions';

export const fetchUser: () => Thunk = () => (dispatch, _, services) =>
  Promise.all([
    services.apiV2.getUser('me'),
    services.apiV2.getUserInformation('me', {
      expand:
        'advertiserBookingsCount,savedPaymentMethodsCount,listingsCount,subscriptionFeatures',
    }),
  ])
    .then(([{ data: user }, { data: userInformation }]) => {
      dispatch(
        AuthLogicActions.initUser({
          user,
          userInformation,
        }),
      );
    })
    .catch(() => {
      dispatch(AuthLogicActions.authDone());
    });
